import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';

import { FuseSharedModule } from '@fuse/shared.module';

import { DetailComponent } from "./detail.component";
import { ControlEncuestasComponent } from './control-encuestas/control-encuestas.component';
import { VisorCorreosModule } from "./visor-correos/visor-correos.module";
import { PreviewEncuestasComponent } from './control-encuestas/preview-encuestas/preview-encuestas.component';
import { DescargaEncuestaComponent } from "./descarga-encuesta/descarga-encuesta.component";

import { PdfMakeWrapper } from 'pdfmake-wrapper';
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { InfoRTComponent } from './info-rt/info-rt.component';
import { ConfigResultComponent } from './config-result/config-result.component';
import { ResultEmprisingComponent } from './result-emprising/result-emprising.component'; // fonts provided for pdfmake
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { FilterPipe } from './config-result/filter.pipe';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { InfraStructComponent } from './infra-struct/infra-struct.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
PdfMakeWrapper.setFonts(pdfFonts);

@NgModule({
    declarations: [
        DetailComponent,
        ControlEncuestasComponent,
        PreviewEncuestasComponent,
        DescargaEncuestaComponent,
        InfoRTComponent,
        ConfigResultComponent,
        ResultEmprisingComponent,
        FilterPipe,
        InfraStructComponent
    ],
    imports     : [
        MatStepperModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        TranslateModule,
        MatExpansionModule,
        MatTooltipModule,
        MatListModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatDialogModule,
        FuseSharedModule,
        VisorCorreosModule,
        RouterModule,
        MatRadioModule,
        MatPaginatorModule,
        MatDatepickerModule,
        DragDropModule,
        NgCircleProgressModule.forRoot({}),
        MatSlideToggleModule
    ],
    entryComponents: [DescargaEncuestaComponent, InfoRTComponent,ConfigResultComponent,ResultEmprisingComponent]
})
export class DetailModule
{
}
